export default {
  statistics: {
    total_campaigns: 'Łączna liczba kampanii',
    todays_sent_messages: 'Wiadomości wysłane dzisiaj',
    total_subscribers: 'Subskrybenci',
    average_click_rate: 'Średni wskaźnik kliknięć',
  },
};
